import React from "react";
import { GiftIcon } from "lucide-react";
import { bonuses } from "../../data/content";
import { SectionCta } from "../SectionCta";
export function Bonuses() {
  return <section className="w-full bg-white py-16 sm:py-20" data-id="element-102" data-mp="1cl62xaqxlmhl">
      <div className="mx-auto max-w-3xl px-4" data-id="element-103" data-mp="1clpkurgl0avm">
        <div className="flex justify-center" data-id="element-104" data-mp="18julhsi7o7kh">
          <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-refer text-white" data-id="element-105" data-mp="18kw0g82cle7h">
            <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-106" data-mp="259bp81xmvjjj" />
          </span>
        </div>
        <h2 className="mt-4 text-center font-serif text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-107" data-mp="20c20yplzddxa">
          5 exclusive bonuses — <em className="text-brand" data-id="element-108" data-mp="1wb9olnhtasws">included today</em>
        </h2>
        <p className="mt-3 text-center text-[17px] text-muted" data-id="element-109" data-mp="1r9aqas0xim6p">
          Worth <strong className="text-ink" data-id="element-110" data-mp="kua1d6abn49m">$197</strong> on their own. Yours free with the system.
        </p>
      </div>

      <div className="mx-auto mt-10 max-w-3xl space-y-12 sm:px-4" data-id="element-111" data-mp="ftvuhrkgi0d6">
        {bonuses.map(b => <article key={b.number} className="overflow-hidden bg-canvas sm:rounded-3xl" data-id="element-112" data-mp="1eupz077vuxyh">
            <img src={b.image} alt={`Bonus #${b.number}: ${b.title}`} className="block w-full bg-white" data-id="element-113" data-mp="1jszuyk1fm2l5" />
            <div className="px-5 py-6 sm:px-8" data-id="element-114" data-mp="15rxb8dxwt4de">
              <div className="flex flex-wrap items-center gap-2" data-id="element-115" data-mp="15vba3c7d6vg3">
                <span className="rounded-lg bg-navy px-3 py-1 text-sm font-black uppercase tracking-wide text-white" data-id="element-116" data-mp="1aqibueh2pq2d">Bonus #{b.number}</span>
                <span className="text-sm font-bold text-muted" data-id="element-117" data-mp="10tvrdqsnt10v">
                  Value: <s data-id="element-118" data-mp="10v6xhx9kukv5">${b.value}</s> <span className="ml-1 text-accept" data-id="element-119" data-mp="10vqftf353b9p">FREE TODAY</span>
                </span>
              </div>
              <h3 className="mt-3 font-serif text-2xl font-black leading-tight text-ink" data-id="element-120" data-mp="r42i4wfzoxzs">{b.title}</h3>
              <p className="mt-2 text-[16px] leading-relaxed text-muted" data-id="element-121" data-mp="d4kyevhjwaxa">{b.text}</p>
            </div>
          </article>)}
      </div>

      <div className="px-4" data-id="element-122" data-mp="i22zy0t8nnv9">
        <SectionCta label="Yes, give me all 5 bonuses" data-id="element-123" data-mp="i5h3vdhjw54t" />
      </div>
    </section>;
}